// app/frontend/channels/consumer.js
// Action Cable is a WebSocket framework for Rails.
// It allows you to add real-time features to your application.
import { createConsumer } from "@rails/actioncable";

// Support custom WebSocket URL via meta tag (useful for ngrok/localxpose tunnels)
// The backend can set this via a meta tag in the layout
function getWebSocketUrl() {
  const currentOrigin = window.location.origin;
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";

  // Check for meta tag first (set by backend for custom domains/tunnels)
  const metaTag = document.querySelector("meta[name=\"action-cable-url\"]");
  if (metaTag && metaTag.content) {
    return metaTag.content;
  }

  // For localhost/127.0.0.1, use localhost directly
  if (currentOrigin.includes("localhost") || currentOrigin.includes("127.0.0.1")) {
    return `${protocol}//localhost:3000/cable`;
  }

  // For ngrok or other tunnels, use the same origin with /cable path
  // This allows the page and WebSocket to use the same tunnel
  if (currentOrigin.includes("ngrok") || currentOrigin.includes("loca.lt") || currentOrigin.includes("localxpose")) {
    return `${protocol}//${window.location.host}/cable`;
  }

  // Production/default: let ActionCable use same origin (undefined)
  return undefined;
}

const wsUrl = getWebSocketUrl();
export default createConsumer(wsUrl);